import { TSData, RiskLabelTree, Frame } from "./type";

export class RiskDataManager {
  rawRiskData: TSData;
  riskLabelTree: RiskLabelTree;
  timeTicks: string[];
  constructor(rawRiskData: TSData) {
    this.rawRiskData = rawRiskData;
    this.riskLabelTree = generateRiskLabelTree(rawRiskData);
    this.timeTicks = generateTimeTicks(rawRiskData);
  }

  getFrameRiskTree(time: string) {
    if (this.timeTicks.includes(time)) {
      const frameRiskLabelTree = {};
      for (const riskType in this.riskLabelTree) {
        if (!frameRiskLabelTree.hasOwnProperty(riskType)) {
          frameRiskLabelTree[riskType] = {};
        }
        for (const riskLabel in this.riskLabelTree[riskType]) {
          const riskValue = this.riskLabelTree[riskType][riskLabel];
          frameRiskLabelTree[riskType][riskLabel] = riskValue[time];
        }
      }
      return frameRiskLabelTree;
    }
    return null;
  }

  getSceneMaxRiskData(scene: Frame[]) {
    const sceneMaxRiskData = this.getFrameRiskTree(`${scene[0].time}`);
    const sceneMaxRiskDataTime = JSON.parse(JSON.stringify(sceneMaxRiskData));
    for (const riskType in sceneMaxRiskDataTime) {
      for (const riskLabel in sceneMaxRiskDataTime[riskType]) {
        sceneMaxRiskDataTime[riskType][riskLabel] = scene[0].time;
      }
    }
    for (let i = 1; i < scene.length; i++) {
      const frameRiskTree = this.getFrameRiskTree(`${scene[i].time}`);
      for (const riskType in frameRiskTree) {
        for (const riskLabel in frameRiskTree[riskType]) {
          if (
            frameRiskTree[riskType][riskLabel] >
            sceneMaxRiskData[riskType][riskLabel]
          ) {
            sceneMaxRiskData[riskType][riskLabel] =
              frameRiskTree[riskType][riskLabel];
            sceneMaxRiskDataTime[riskType][riskLabel] = scene[i].time;
          }
        }
      }
    }
    // console.log('wyh-test', sceneRiskMaxData, sceneRiskMaxDataTime);
    return {
      sceneMaxRiskData: sceneMaxRiskData,
      sceneMaxRiskDataTime: sceneMaxRiskDataTime, // 这里的逻辑还没确定（目前交互是riskLabel层级的）
    };
  }

  getFrameRiskMax(scene: Frame[]) {
    let maxRiskFrameIndex = 0;
    let maxRiskValue = 0;
    for (let i = 0; i < scene.length; i++) {
      const frameRiskTree = this.getFrameRiskTree(`${scene[i].time}`);
      for (const riskType in frameRiskTree) {
        for (const riskLabel in frameRiskTree[riskType]) {
          if (frameRiskTree[riskType][riskLabel] > maxRiskValue) {
            maxRiskValue = frameRiskTree[riskType][riskLabel];
            maxRiskFrameIndex = i;
          }
        }
      }
    }
    return scene[maxRiskFrameIndex];
  }

  getFrameRiskSumMax(scene: Frame[]) {
    let maxRiskFrameIndex = 0;
    let maxRiskValue = 0;
    for (let i = 0; i < scene.length; i++) {
      const frameRiskTree = this.getFrameRiskTree(`${scene[i].time}`);
      let sum = 0;
      for (const riskType in frameRiskTree) {
        for (const riskLabel in frameRiskTree[riskType]) {
          sum += frameRiskTree[riskType][riskLabel];
        }
      }
      if (sum > maxRiskValue) {
        maxRiskValue = sum;
        maxRiskFrameIndex = i;
      }
    }
    // return scene[maxRiskFrameIndex];
    return JSON.parse(JSON.stringify(scene[maxRiskFrameIndex]));
  }

  getFrameViewData(scenes: Frame[][]) {
    const scenesMaxRiskData = scenes.map((scene) =>
      this.getSceneMaxRiskData(scene)
    );
    const scenesMaxRiskSum = scenesMaxRiskData.map((sceneData) =>
      computeRiskSum(sceneData.sceneMaxRiskData)
    );
    const scenesData = JSON.parse(JSON.stringify(scenes));
    for (let i = 0; i < scenesMaxRiskSum.length - 1; i++) {
      for (let j = i + 1; j < scenesMaxRiskSum.length; j++) {
        if (scenesMaxRiskSum[i] < scenesMaxRiskSum[j]) {
          const t = scenesMaxRiskSum[i];
          scenesMaxRiskSum[i] = scenesMaxRiskSum[j];
          scenesMaxRiskSum[j] = t;
          const tframe = scenesData[i];
          scenesData[i] = scenesData[j];
          scenesData[j] = tframe;
          const trisk = scenesMaxRiskData[i];
          scenesMaxRiskData[i] = scenesMaxRiskData[j];
          scenesMaxRiskData[j] = trisk;
        }
      }
    }
    const scenesMaxRiskFrame = scenesData.map((scene) =>
      // this.getFrameRiskMax(scene)
      this.getFrameRiskSumMax(scene)
    );
    // console.log('wyh-test-02', scenesMaxRiskFrame)
    return {
      scenesMaxRiskData: scenesMaxRiskData,
      scenesMaxRiskFrame: scenesMaxRiskFrame,
      frameViewData: scenesData,
    };
  }
}

function generateTimeTicks(rawRiskData: TSData) {
  for (const label in rawRiskData) {
    const tskv = rawRiskData[label];
    const tskeys = Object.keys(tskv);
    tskeys.sort((a, b) => parseFloat(a) - parseFloat(b));
    return tskeys;
  }
  return [];
}

function generateRiskLabelTree(rawRiskData: TSData) {
  const rawRiskLabels = Object.keys(rawRiskData);
  const riskLabelTree = {};
  for (let i = 0, len = rawRiskLabels.length; i < len; i++) {
    const riskLabel = rawRiskLabels[i];
    const riskValue = rawRiskData[riskLabel];
    if (aggregateArr(Object.values(riskValue)) > 0) {
      riskDataProtocV1(riskLabelTree, riskLabel, riskValue);
    }
  }
  return riskLabelTree;
}

function aggregateArr(arr) {
  const reducer = (accumulator, currentValue) => accumulator + currentValue;
  return arr.reduce(reducer);
}

// 采用风险数据协议v1
function riskDataProtocV1(riskLabelTree, riskLabel, riskValue) {
  let riskLabelTags = riskLabel
    .split("_")
    .filter((tag) => tag !== "Det" && tag !== "v0");
  if (riskLabelTags[1] === "情趣品") {
    riskLabelTags = [aggregateArr(riskLabelTags)];
  }
  switch (riskLabelTags.length) {
    case 1:
      if (!riskLabelTree.hasOwnProperty("低俗色情")) {
        riskLabelTree["低俗色情"] = {};
      }
      riskLabelTree["低俗色情"][riskLabelTags[0]] = riskValue;
      break;
    case 2:
      if (!riskLabelTree.hasOwnProperty(riskLabelTags[0])) {
        riskLabelTree[riskLabelTags[0]] = {};
      }
      riskLabelTree[riskLabelTags[0]][riskLabelTags[1]] = riskValue;
      break;
    default:
      break;
  }
}

export function computeRiskSum(
  sceneData: Record<string, Record<string, number>>
) {
  let sum = 0;
  for (const riskType in sceneData) {
    for (const riskLabel in sceneData[riskType]) {
      sum += sceneData[riskType][riskLabel];
    }
  }
  return sum;
}

export function normalization(numArray: number[]) {
  let sum = 0;
  for (let i = 0; i < numArray.length; i++) {
    sum += numArray[i];
  }
  return numArray.map((num) => num / sum);
}
